"use client";

import { useMemo, useState } from "react";

export default function RedemptionInfo({ instructions = [], pdfUrl = "" }) {
  const [open, setOpen] = useState(false);

  const formatDeliveryType = (type) =>
    type ? type.replace(/([a-z])([A-Z])/g, "$1 $2").toUpperCase() : "";

  const uniqueInstructions = useMemo(() => {
    if (!Array.isArray(instructions) || instructions.length === 0) return [];
    return Array.from(
      new Map(
        instructions.map((item) => [
          `${item?.language?.toUpperCase?.() || "EN"}|${formatDeliveryType(item?.deliveryType)}`,
          item,
        ])
      ).values()
    );
  }, [instructions]);

  if (uniqueInstructions.length === 0 && !pdfUrl) return null;

  return (
    <div className="mt-6 text-sm text-textSecondary">
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="w-full text-left bg-muted p-3 rounded-md shadow hover:bg-hover transition text-textPrimary font-semibold"
      >
        🎁 Redemption Info {open ? "▲" : "▼"}
      </button>

      {open && (
        <div className="mt-3 space-y-4">
          {uniqueInstructions.map((instruction, idx) => (
            <div key={idx} className="flex items-center gap-2">
              <span>🌐 {instruction?.language?.toUpperCase?.() || "EN"}</span>
              <span>– {formatDeliveryType(instruction?.deliveryType)}</span>
            </div>
          ))}

          {pdfUrl && (
            <div>
              <span>📄 Additional info available after purchase</span>
            </div>
          )}

          <div className="p-3 rounded-md bg-background border border-border text-xs leading-relaxed">
            <strong className="text-textPrimary block mb-2">ℹ️ Please note:</strong>
            After a successful purchase, your <span className="text-accent">transaction history</span> will show a secure redemption link. This could be:
            <ul className="list-disc list-inside mt-1 ml-2">
              <li>PIN code</li>
              <li>PIN voucher</li>
              <li>Direct redemption link</li>
            </ul>
            <p className="mt-2">For your privacy and security:</p>
            <ul className="list-disc list-inside ml-2">
              <li>Do <strong>not share</strong> your link or code.</li>
              <li>Avoid redeeming while someone watches your screen.</li>
              <li><strong>Screenshot</strong> or save it securely.</li>
              <li>Redeem as soon as possible to avoid misuse.</li>
            </ul>
          </div>

          <div className="p-4 rounded-md bg-surface border border-border text-xs leading-relaxed">
            <strong className="block text-textPrimary mb-2">📌 Important Notice</strong>
            ReloadPI is a digital storefront using Pi Coin. After product delivery, <strong className="text-accent">ReloadPI does not retain access</strong> to the voucher.
            <ul className="list-disc list-inside ml-2 mt-2">
              <li>No responsibility for lost, expired, or misused vouchers</li>
              <li>No refunds or replacements once delivered</li>
            </ul>
          </div>
        </div>
      )}
    </div>
  );
}
